module.exports = __webpack_public_path__ + "img/item3-2.91ce47d2.jpg";